import { useState } from "react";

export function AuditPage() {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    const form = new FormData(e.currentTarget);
    const body = {
      companyName: form.get("companyName"),
      url: form.get("url"),
      email: form.get("email"),
      employeesRange: form.get("employeesRange") || undefined,
      sector: form.get("sector") || undefined,
    };
    try {
      const res = await fetch("/api/audit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        const errBody = (await res.json().catch(() => ({}))) as { message?: string };
        throw new Error(errBody.message ?? `HTTP ${res.status}`);
      }
      setSubmitted(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setSubmitting(false);
    }
  }

  if (submitted) {
    return (
      <main className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--color-bg)" }}>
        <div className="max-w-xl text-center">
          <h1 className="text-4xl mb-4" style={{ fontFamily: "Instrument Serif, serif", fontStyle: "italic", color: "var(--color-accent)" }}>
            Audit en cours
          </h1>
          <p className="text-lg" style={{ color: "var(--color-text)" }}>
            Notre Integrator est en train de scanner votre site. Vous recevrez le rapport personnalisé par email dans 5-10 minutes.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-12" style={{ background: "var(--color-bg)" }}>
      <div className="max-w-xl w-full">
        <h1 className="text-5xl mb-4" style={{ fontFamily: "Instrument Serif, serif", fontStyle: "italic", color: "var(--color-accent)" }}>
          Audit IA gratuit
        </h1>
        <p className="text-lg mb-8" style={{ color: "var(--color-text-muted)" }}>
          Découvrez en 15 minutes ce que l'IA peut automatiser dans votre business. Rapport personnalisé livré par email.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input name="companyName" required placeholder="Nom de votre entreprise" className="w-full px-4 py-3 rounded" style={{ background: "var(--color-bg-card)", color: "var(--color-text)", border: "1px solid var(--color-text-dim)" }} />
          <input name="url" type="url" required placeholder="https://votre-site.fr" className="w-full px-4 py-3 rounded" style={{ background: "var(--color-bg-card)", color: "var(--color-text)", border: "1px solid var(--color-text-dim)" }} />
          <input name="email" type="email" required placeholder="votre@email.fr" className="w-full px-4 py-3 rounded" style={{ background: "var(--color-bg-card)", color: "var(--color-text)", border: "1px solid var(--color-text-dim)" }} />
          <input name="employeesRange" placeholder="Effectif (ex: 10-50)" className="w-full px-4 py-3 rounded" style={{ background: "var(--color-bg-card)", color: "var(--color-text)", border: "1px solid var(--color-text-dim)" }} />
          <input name="sector" placeholder="Secteur (ex: conseil, e-commerce)" className="w-full px-4 py-3 rounded" style={{ background: "var(--color-bg-card)", color: "var(--color-text)", border: "1px solid var(--color-text-dim)" }} />
          {error && (
            <div className="px-4 py-3 rounded text-sm" style={{ background: "var(--color-status-error)", color: "white" }}>
              {error}
            </div>
          )}
          <button type="submit" disabled={submitting} className="w-full px-6 py-3 rounded font-mono uppercase tracking-wider" style={{ background: "var(--color-accent)", color: "var(--color-bg)" }}>
            {submitting ? "Envoi…" : "Lancer l'audit gratuit"}
          </button>
        </form>
      </div>
    </main>
  );
}
